import { InputNumber } from 'primereact/inputnumber';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  ThematicPackageUpsellFields,
  ThematicPackageUpsellFormValues,
} from '@features/campaigns/thematicPackage/containers/ThematicPackageUpsellPage/ThematicPackageUpsellPage.types.ts';
import { CustomBudgetBounds } from '@features/campaigns/thematicPackage/types/thematicPackage.types.ts';
import fieldStyles from '@shared/components/FormFields/FormFields.module.scss';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { formatNumberAsMoney } from '@shared/utils/moneyFormat.ts';

import styles from './FieldCustomBudgetAmount.module.scss';

interface FieldCustomBudgetAmountProps {
  customBudgetBounds: CustomBudgetBounds;
}

export function FieldCustomBudgetAmount({ customBudgetBounds }: FieldCustomBudgetAmountProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const { control } = useFormContext<ThematicPackageUpsellFormValues>();

  return (
    <div className={fieldStyles.fieldWrapper}>
      <label htmlFor={ThematicPackageUpsellFields.CUSTOM_BUDGET_AMOUNT} className={fieldStyles.fieldLabel}>
        {t('thematicPackage.budget.setBudgetLabel')}
      </label>

      <Controller
        control={control}
        name={ThematicPackageUpsellFields.CUSTOM_BUDGET_AMOUNT}
        render={({ field }) => (
          <span className='p-input-icon-left'>
            <i className='pi pi-euro' />
            <InputNumber
              {...field}
              id={ThematicPackageUpsellFields.CUSTOM_BUDGET_AMOUNT}
              onChange={(event) => field.onChange(event.value)}
              // Not `min={minimumAmount}`: InputNumber clamps while typing, so the first digit
              // would jump to the minimum. The floor is enforced by the schema instead.
              min={0}
              maxLength={12}
              placeholder={t('thematicPackage.budget.customAmountPlaceholder')}
              data-testid='field-custom-budget-amount'
            />
          </span>
        )}
      />

      <span className={styles.minimumAmountHint}>
        {t('thematicPackage.budget.minimumAmountHint', {
          minimumAmount: formatNumberAsMoney(customBudgetBounds.minimumAmount),
        })}
      </span>
    </div>
  );
}
